<button class="btn left-dashboard-show btn-animation btn-md fw-bold d-block mb-4 d-lg-none" (click)="classShow()">Show
  Menu</button>
<div class="dashboard-left-sidebar" [ngClass]="siteBarshowHide ? 'show' : '' ">
    <div class="close-button d-flex d-lg-none">
        <button class="close-sidebar" (click)="classHide()">
      <i class="fa-solid fa-xmark"></i>
    </button>
    </div>
    <div class="profile-box">
        <div class="cover-image">
            <img src="assets/images/inner-page/cover-img.jpg" class="img-fluid blur-up lazyload" alt>
        </div>

        <div class="profile-contain">
            <div class="profile-image">
                <div class="position-relative">
                    <!-- <img src="assets/images/inner-page/user/1.jpg" class="blur-up lazyload update_img" alt> -->
                    <div class="cover-icon">
                        <img [src]="DataList.image ? imageBaseUrl + DataList.image : 'assets/images/inner-page/user/1.jpg'" class="blur-up lazyload update_img" alt="Banner Image" />
                        <!-- <i class="fa-solid fa-pen">
              <input type="file" onchange="readURL(this,0)">
            </i> -->
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div class="profile-name">
                <h3>{{ DataList.name || "" }} {{ DataList.last_name || "" }}</h3>
                <h6 class="text-content">{{ DataList.email || "" }}</h6>
            </div>
        </div>
    </div>

    <ul class="nav nav-pills user-nav-pills" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
            <button (click)="classHide()" class="nav-link " [ngClass]="activeTab == '/users/account/dashboard' ? 'active' : ''" [routerLink]="['/users/account/dashboard']" routerLinkActive="active-link-class" [routerLinkActiveOptions]="{ exact: true }" id="pills-dashboard-tab"
                data-bs-toggle="pill" data-bs-target="#pills-dashboard" type="button"><i
          data-feather="home"></i>
        DashBoard</button>
        </li>
        <li class="nav-item" role="presentation">
            <button (click)="classHide()" class="nav-link" [ngClass]="activeTab == '/users/account/order-history' ? 'active' : ''" id="pills-order-tab" [routerLink]="['/users/account/order-history']" routerLinkActive="active-link-class" [routerLinkActiveOptions]="{ exact: true }"
                data-bs-toggle="pill" data-bs-target="#pills-order" type="button"><i
          data-feather="shopping-bag"></i>Order</button>
        </li>
        <li class="nav-item" role="presentation">
            <button (click)="classHide()" class="nav-link" [ngClass]="activeTab == '/users/account/wishlist-list' ? 'active' : ''" id="pills-wishlist-tab" data-bs-toggle="pill" [routerLink]="['/users/account/wishlist-list']" routerLinkActive="active-link-class" [routerLinkActiveOptions]="{ exact: true }"
                data-bs-target="#pills-wishlist" type="button"><i
          data-feather="heart"></i>
        Wishlist</button>
        </li>

        <li class="nav-item" role="presentation">
            <button (click)="classHide()" class="nav-link" [ngClass]="activeTab == '/users/account//user-address' ? 'active' : ''" id="pills-address-tab" data-bs-toggle="pill" [routerLink]="['/users/account/user-address']" routerLinkActive="active-link-class" [routerLinkActiveOptions]="{ exact: true }"
                data-bs-target="#pills-address" type="button" role="tab"><i
          data-feather="map-pin"></i>Address</button>
        </li>

        <li class="nav-item" role="presentation">
            <button (click)="classHide()" class="nav-link " [ngClass]="activeTab == '/users/account/refund-replace-order' ? 'active' : ''" [routerLink]="['/users/account/refund-replace-order']" routerLinkActive="active-link-class" [routerLinkActiveOptions]="{ exact: true }"
                id="pills-dashboard-tab" data-bs-toggle="pill" data-bs-target="#pills-dashboard" type="button"><i
          data-feather="shield"></i>
        Return/Refund Order</button>
        </li>
        <li class="nav-item" role="presentation">
            <button (click)="classHide()" class="nav-link" id="pills-profile-tab" [ngClass]="activeTab == '/users/account/replace-return-policy' ? 'active' : ''" data-bs-toggle="pill" [routerLink]="['/users/account/replace-return-policy']" routerLinkActive="active-link-class"
                [routerLinkActiveOptions]="{ exact: true }" data-bs-target="#pills-profile" type="button" role="tab"><i
          data-feather="user"></i>
        Replace & Return Policy</button>
        </li>
        <li class="nav-item" role="presentation">
            <button (click)="classHide()" class="nav-link" id="pills-profile-tab" [ngClass]="activeTab == '/users/account/delete-account' ? 'active' : ''" data-bs-toggle="pill" [routerLink]="['/users/account/delete-account']" routerLinkActive="active-link-class"
                [routerLinkActiveOptions]="{ exact: true }" data-bs-target="#pills-profile" type="button" role="tab"><i
        data-feather="user"></i>
      Delete Acount</button>
        </li>
        <!-- <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" [routerLink]="['/users/account/user-profile']" routerLinkActive="active-link-class" [routerLinkActiveOptions]="{ exact: true }" data-bs-target="#pills-profile" type="button" role="tab"><i
          data-feather="user"></i>
        Profile</button>
        </li> -->

        <!-- <li class="nav-item" role="presentation">
            <button class="nav-link" id="pills-security-tab" (click)="logout()"><i
          data-feather="shield"></i>
        Logout</button>
        </li> -->
    </ul>
</div>
